import { render, staticRenderFns } from "./TaskUnarchived.vue?vue&type=template&id=57dce8f4&scoped=true"
import script from "./TaskUnarchived.vue?vue&type=script&lang=js"
export * from "./TaskUnarchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dce8f4",
  null
  
)

export default component.exports